import { MODULE_NAME } from '../constants/modules';

export const fetchyeReporter = ({
  component,
}) => ({ key, options, error }) => ({
  moduleID: MODULE_NAME,
  component,
  fetch: {
    url: key,
    correlationId: options?.headers?.correlationId,
    status: error?.status,
  },
});
